import { render, staticRenderFns } from "./HandSecond.vue?vue&type=template&id=770c67dc&"
import script from "./HandSecond.vue?vue&type=script&lang=js&"
export * from "./HandSecond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HandSecond.vue"
export default component.exports